<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">{{ dicts.kwitansi[dicts.lang] }}</h4>
					<button class="float-right btn btn-primary shadow mt-2" v-on:click="formActive=!formActive">
						{{ dicts.button_add_kwitansi[dicts.lang] }}
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formActive">
						<div class="row p-3 mx-2 bg-white shadow">
							<div class="col-12 mb-3">
								<h4 class="my-0 py-0">{{ dicts.form_kwitansi[dicts.lang] }}</h4>
								<hr>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.kwitansi_type[dicts.lang] }} <span
									style="color:red;">*</span></label>
								<!-- <smart-search direct init url="/api/master/seeker/kwitansitype" key-tag="kwitansi_type_name" v-on:update="(data)=>smartSearchAddType(data)" :search-value="newkwitansitypelabel" @update-direct="(label)=>newkwitansitypelabel=label"></smart-search> -->
								<smart-select name="type" :options="TypeOptions"
								              v-on:update="smartSelectAddType"></smart-select>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.kwitansi_number[dicts.lang] }} <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded" v-model="newKwitansi.receiptNo"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2"
							     v-if="['repair','replacement'].includes(newKwitansi.type)">
								<label class="d-block">{{ dicts.data_troubleshoot[dicts.lang] }} <span
									style="color:red;">*</span></label>
								<smart-search key="referencedata" @clear="clearReference"
								              v-if="['repair','replacement'].includes(newKwitansi.type)" init
								              url="/api/v2/seeker/troubleshoot" key-tag="all"
								              :label-tag="['technician_name','hardware_setup.id_transmitter']"
								              v-on:update="(data)=>smartSearchAddTroubleshoot(data)"
								              :search-value="newtroubleshootlabel"
								              @update-direct="(label)=>newtroubleshootlabel=label"></smart-search>
							</div>

							<div class="col-12 col-md-6 col-lg-4 mt-2"
							     v-if="['substitution'].includes(newKwitansi.type)">
								<label class="d-block">{{ dicts.client[dicts.lang] }} <span style="color:red;">*</span></label>
								<!-- <input type="text" class="form-control w-100 rounded" v-model="newKwitansi.application_name" /> -->
								<smart-search key="clientdata" v-if="['substitution'].includes(newKwitansi.type)" init
								              url="/api/master/v2/seeker/klien" key-tag="legal_name"
								              :label-tag="['legal_name','customer_id']"
								              v-on:update="(data)=>smartSearchaddClient(data)"
								              :search-value="newclientlabel"
								              @update-direct="(label)=>newclientlabel=label"></smart-search>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2"
							     v-if="['repair','replacement'].includes(newKwitansi.type)">
								<label class="d-block">{{ dicts.client[dicts.lang] }} <span style="color:red;">*</span></label>
								<div class="form-control w-100 rounded">
									{{
										selectedHardwareSetup.hardware_setup != undefined && selectedHardwareSetup.hardware_setup.vessel.client.legal_name != null ? selectedHardwareSetup.hardware_setup.vessel.client.legal_name : "-"
									}}
								</div>
								<!-- <input type="text" class="form-control w-100 rounded" v-model="newKwitansi.clientName"/> -->
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2"
							     v-if="['repair','replacement'].includes(newKwitansi.type)">
								<label class="d-block">{{ dicts.no_jb[dicts.lang] }} <span
									style="color:red;">*</span></label>
								<div class="form-control w-100 rounded">
									{{
										selectedHardwareSetup.hardware_setup != undefined && selectedHardwareSetup.hardware_setup.jb != null ? selectedHardwareSetup.hardware_setup.jb.serial_number : "-"
									}}
								</div>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2"
							     v-if="['substitution','replacement'].includes(newKwitansi.type)">
								<label class="d-block">{{ dicts.no_jb_new[dicts.lang] }} <span
									style="color:red;">*</span></label>
								<!-- <input type="text" class="form-control w-100 rounded" v-model="newKwitansi.hardwareQCMetadataId" /> -->
								<smart-search init url="/api/inventaris/seeker/hardware-qc-metadata"
								              :addon="{item:'jb'}" key-tag="serial_number"
								              :label-tag="['serial_number']"
								              v-on:update="(data)=>smartSearchAddJB(data)" :search-value="newjblabel"
								              @update-direct="(label)=>newjblabel=label"></smart-search>
							</div>
							<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Harga <span style="color:red;">*</span></label>
								<input type="number" class="form-control w-100 rounded" v-model="newKwitansi.price" />
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Diskon <span style="color:red;">*</span></label>
								<input type="number" class="form-control w-100 rounded" v-model="newKwitansi.discount" />
							</div> -->
							<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Total <span style="color:red;">*</span></label>
								<input type="number" class="form-control w-100 rounded" v-model="newKwitansi.total" />
							</div> -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.date[dicts.lang] }} <span
									style="color:red;">*</span></label>
								<b-form-datepicker today-button reset-button close-button
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
									id="add-receipt-date" v-model="newKwitansi.receiptDate" class="mb-2">
									{{ newKwitansi.receiptDate }}
								</b-form-datepicker>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.admin_name[dicts.lang] }} <span
									style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded" v-model="newKwitansi.pic"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.tax[dicts.lang] }}</label>
								<!-- <smart-select name="ppn" :options="ppnTypeOptions"
								              v-on:update="addNewPpn"></smart-select> -->
								<smart-select name="ppn" 
									:options="ppnTypeOptions" 
									:value="newKwitansi.ppn" 
									v-on:update="addNewPpn">
								</smart-select>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.note[dicts.lang] }} <span
									style="color:red;">*</span></label>
								<textarea class="form-control w-100 rounded" v-model="newKwitansi.notes"/>
							</div>
							<div class="col-12 mt-2">
								<br>
								<hr>
								<div class="row py-2" style="background:#f0f0f0">
									<div class="col-12 col-md-3 pb-2">
										<label class="d-block">{{ dicts.price[dicts.lang] }}</label>
										<input type="number" class="form-control w-100 rounded"
										       v-model="newKwitansi.price" @input="calculateAmount()"/>
									</div>
									<div class="col-12 col-md-3 pb-2">
										<label class="d-block">{{ dicts.discount[dicts.lang] }}</label>
										<input type="number" class="form-control w-100 rounded"
										       v-model="newKwitansi.discount" @input="calculateAmount()"/>
									</div>
									<div class="col-12 col-md-2 pb-2">
										<label class="d-block">Subtotal</label>
										<div type="text" class="form-control w-100 rounded">
											{{ newKwitansi.subtotal | numeral("0,0") }}
										</div>
									</div>
									<div class="col-12 col-md-2 pb-2">
										<label class="d-block">{{ dicts.total_tax[dicts.lang] }}</label>
										<div type="text" class="form-control w-100 rounded">
											{{ newKwitansi.totalPPN | numeral("0,0") }}
										</div>
									</div>
									<div class="col-12 col-md-2 pb-2">
										<label class="d-block">Total</label>
										<div type="text" class="form-control w-100 rounded">
											{{ newKwitansi.total | numeral("0,0") }}
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="newSaved">
									<div class="alert alert-success" role="alert">
										Berhasil Menyimpan Kwitansi Baru.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorNew">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">{{ createErrorMessage }}</p>
										</div>
										<div v-for="err in errorList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1 w-100">
												{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="savingNew">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button" v-on:click="saveNewKwitansi">
									{{ dicts.submit[dicts.lang] }}
								</button>
							</div>
						</div>
					</div>
				</transition>


				<div class="col-12  my-2 py-0">
					<datatable :currentIdx="currentPage" :lang="dicts.lang" :datas="kwitansis"
					           :structure="TableStructure" :init="loadData"
					           :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
					           use-filter use-seeker seeker-url="/api/pemesanan/seeker/kwitansi-item"
					           @refetch="(row)=>{rowLimit=row;getKwitansi()}"
					           @searching="(val)=>!val.status?getKwitansi():kwitansis=val.data">
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.no_kwitansi[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.receipt_no }}</b>
										</div>
										<hr class="my-1">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.type[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												translateType(obj.type)
											}}</b>
										</div>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Keterangan:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.notes }}</b>
										</div>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Total:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">Rp
											{{ obj.total | numeral("0,0") }}</b>
										</div>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Tanggal:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ obj.receipt_date | timeformat }}</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<b-button class="btn btn-warning mr-2 mb-1"
											          :href="$baseUrl+'/api/invoice/kwitansi/'+obj.id"
											          title="kwitansi">
												<b-icon icon="printer"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-detail-kwitansi class="btn btn-primary mr-2 mb-1"
											          v-on:click="selectedDetail=index">
												<b-icon icon="eye"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-edit-kwitansi class="btn btn-info mr-2 mb-1"
											          v-on:click="editPreparation(index)"
											          v-if="['master_admin','admin'].includes(role)">
												<b-icon icon="pencil-square"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-delete
											          v-on:click="deleteId=obj.id;itemToDelete=obj"
											          class="btn btn-danger mr-2 mb-1"
											          v-if="['master_admin','admin'].includes(role)">
												<b-icon icon="trash"></b-icon>
											</b-button>
										</div>
									</li>
								</ul>
							</td>
							<td v-if="!isMobile">{{ index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.receipt_no }}</td>
							<td v-if="!isMobile">{{ translateType(obj.type) }}</td>
							<td v-if="!isMobile">{{ obj.notes }}</td>
							<td v-if="!isMobile">Rp {{ obj.total | numeral("0,0") }}</td>
							<td v-if="!isMobile">{{ obj.receipt_date | timeformat }}</td>
							<td v-if="!isMobile">
								<b-button class="btn btn-warning mr-2 mb-1"
								          :href="'https://api-billing.megahsurya.com/api/invoice/kwitansi/'+obj.id"
								          title="kwitansi">
									<b-icon icon="printer"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-detail-kwitansi class="btn btn-primary mr-2 mb-1"
								          v-on:click="selectedDetail=index">
									<b-icon icon="eye"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-edit-kwitansi class="btn btn-info mr-2 mb-1"
								          v-on:click="editPreparation(index)"
								          v-if="['master_admin','admin'].includes(role)">
									<b-icon icon="pencil-square"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj"
								          class="btn btn-danger mr-2 mb-1"
								          v-if="['master_admin','admin'].includes(role)">
									<b-icon icon="trash"></b-icon>
								</b-button>
							</td>
						</template>
					</datatable>
				</div>

				<b-modal no-close-on-esc content-class="m-0" id="modal-edit-kwitansi" title="Edit kwitansi" scrollable
				         no-close-on-backdrop size="lg" @hide="editModalClose" v-if="kwitansis.length>0">
					<b-container fluid>
						<b-row class="mt-3 pt-1" v-if="kwitansis[selectedKwitansi]!=undefined">
							<b-col cols="12" class="my-1">
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">{{ dicts.kwitansi_type[dicts.lang] }}</label>
								<smart-select name="type" usedefault
								              :default-value="translateType(kwitansis[selectedKwitansi].type)"
								              :options="TypeOptions"
								              v-on:update="(value)=>{kwitansis[selectedKwitansi].type=value}"></smart-select>
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">{{ dicts.kwitansi_number[dicts.lang] }}</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="kwitansis[selectedKwitansi].receipt_no"/>
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">Tanggal</label>
								<b-form-datepicker today-button reset-button close-button
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
									id="datepicker-test-date" v-model="kwitansis[selectedKwitansi].receipt_date"
									class="mb-2">{{ kwitansis[selectedKwitansi].receipt_date }}
								</b-form-datepicker>
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">PPN</label>
								<smart-select name="ppn" usedefault
								              :default-value="translatePPN(kwitansis[selectedKwitansi].ppn)"
								              :options="ppnTypeOptions" v-on:update="updateNewPpn"></smart-select>
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">Keterangan</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="kwitansis[selectedKwitansi].notes"/>
							</b-col>
							<div class="col-12 mt-2">
								<br>
								<hr>
								<div class="row py-2" style="background:#f0f0f0">
									<b-col cols="12" md="6" lg="3">
										<label class="d-block">Harga</label>
										<input type="number" class="form-control w-100 rounded"
										       v-model="kwitansis[selectedKwitansi].price"
										       @input="calculateAmountUpdate()"/>
									</b-col>
									<b-col cols="12" md="6" lg="3">
										<label class="d-block">Diskon</label>
										<input type="number" class="form-control w-100 rounded"
										       v-model="kwitansis[selectedKwitansi].discount"
										       @input="calculateAmountUpdate()"/>
									</b-col>
									<b-col cols="12" md="6" lg="2">
										<label class="d-block">Subtotal</label>
										<div type="number" class="form-control w-100 rounded">
											{{ kwitansis[selectedKwitansi].subtotal | numeral("0,0") }}
										</div>
									</b-col>
									<b-col cols="12" md="6" lg="2">
										<label class="d-block">Total PPN</label>
										<div type="number" class="form-control w-100 rounded">{{
												(kwitansis[selectedKwitansi].ppn == "yes" ? (parseInt(kwitansis[selectedKwitansi].subtotal) * (this.base_ppn/100) ) : 0) | numeral("0,0")
											}}
										</div>
									</b-col>
									<b-col cols="12" md="6" lg="2">
										<label class="d-block">Total</label>
										<div type="number" class="form-control w-100 rounded">
											{{ kwitansis[selectedKwitansi].total | numeral("0,0") }}
										</div>
									</b-col>
								</div>
							</div>

							<b-col cols="12" class="my-3 text-right" v-if="updateState">
								<div class="d-flex align-items-center justify-content-start">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
							</b-col>
							<div class="col-12 mt-3" v-if="updateSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-success" role="alert">
										Berhasil update data aplikasi.
									</div>
								</div>
							</div>
							<div class="col-12 mt-3" v-if="errorSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-danger" role="alert">
										Gagal update data aplikasi.
									</div>
								</div>
							</div>
							<b-col cols="12" class="my-3 text-right">
								<button class="btn btn-info" v-on:click="updateData">Simpan</button>
							</b-col>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary mr-2"
							          @click="(!updateState&&!updateState)?$bvModal.hide('modal-edit-kwitansi'):''">
								Tutup
							</b-button>
							<!-- <button class="btn btn-info" v-on:click="updateClientData">submit</button> -->
						</div>
					</template>
				</b-modal>

				<b-modal no-close-on-esc content-class="m-0" size="lg" title="Detail kwitansi"
				         id="modal-detail-kwitansi" scrollable no-close-on-backdrop>
					<b-container fluid v-if="!loadData&&kwitansis.length>0">
						<b-row class="pt-1" v-if="kwitansis[selectedDetail]!=undefined">
							<b-col cols="12">
								<table v-if="kwitansis.length>0" rules="rows" class="table w-100"
								       style="overflow-x:auto;">
									<tbody>
									<tr>
										<th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt"
										    colspan="2" scope="row">Detail kwitansi
										</th>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.kwitansi_type[dicts.lang] }}</th>
										<td class="">{{ translateType(kwitansis[selectedDetail].type) }}</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.kwitansi_number[dicts.lang] }}</th>
										<td class="">{{ kwitansis[selectedDetail].receipt_no }}</td>
									</tr>
									<tr v-if="['repair','replacement'].includes(kwitansis[selectedDetail].type)">
										<th class="" scope="row">{{ dicts.data_troubleshoot[dicts.lang] }}</th>
										<td class="">{{ kwitansis[selectedDetail].reference_id }}</td>
									</tr>
									<tr v-if="['repair','replacement'].includes(kwitansis[selectedDetail].type)">
										<th class="" scope="row">Nama kapal</th>
										<td class="">{{ kwitansis[selectedDetail].client_name }}</td>
									</tr>
									<tr v-if="['repair','replacement'].includes(kwitansis[selectedDetail].type)">
										<th class="" scope="row">Nomor JB</th>
										<td class="">
											{{ kwitansis[selectedDetail].troubleshoot.hardware_setup.jb.serial_number }}
										</td>
									</tr>
									<tr v-if="['substitution'].includes(kwitansis[selectedDetail].type)">
										<th class="" scope="row">Pelanggan</th>
										<td class="">{{ kwitansis[selectedDetail].client_name }}</td>
									</tr>
									<tr v-if="['substitution','replacement'].includes(kwitansis[selectedDetail].type)">
										<th class="" scope="row">Nomor JB baru</th>
										<td class="">
											{{
												kwitansis[selectedDetail].qc_metadata ? kwitansis[selectedDetail].qc_metadata.serial_number : "-"
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">Tanggal</th>
										<td class="">{{ kwitansis[selectedDetail].receipt_date | timeformat }}</td>
									</tr>
									<tr>
										<th class="" scope="row">Nama admin</th>
										<td class="">{{ kwitansis[selectedDetail].pic }}</td>
									</tr>
									<tr>
										<th class="" scope="row">PPN</th>
										<td class="">{{ translatePPN(kwitansis[selectedDetail].ppn) }}</td>
									</tr>
									<tr>
										<th class="" scope="row">Harga</th>
										<td class="">Rp {{ kwitansis[selectedDetail].price | numeral("0,0") }}</td>
									</tr>
									<tr>
										<th class="" scope="row">Diskon</th>
										<td class="">Rp {{ kwitansis[selectedDetail].discount | numeral("0,0") }}</td>
									</tr>
									<tr>
										<th class="" scope="row">Subtotal</th>
										<td class="">Rp {{ kwitansis[selectedDetail].subtotal | numeral("0,0") }}</td>
									</tr>
									<tr>
										<th class="" scope="row">Total PPN</th>
										<td class="">Rp {{
												(kwitansis[selectedDetail].ppn == "yes" ? (parseInt(kwitansis[selectedDetail].subtotal) *(this.base_ppn/100)) : 0) | numeral("0,0")
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">Total</th>
										<td class="">Rp {{ kwitansis[selectedDetail].total | numeral("0,0") }}</td>
									</tr>
									<tr>
										<th class="" scope="row">Keterangan</th>
										<td class="">{{ kwitansis[selectedDetail].notes }}</td>
									</tr>

									</tbody>
								</table>
							</b-col>
						</b-row>
					</b-container>

					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary" @click="!$bvModal.hide('modal-detail-kwitansi')">Tutup
							</b-button>
						</div>
					</template>

				</b-modal>

				<modal-delete url="/api/pemesanan/kwitansi-item/" @read="()=>{console.log('modal ready')}"
				              @result="deleteResult" :targetid="deleteId">
					Yakin mau menghapus data dengan detail berikut :<br>
					<ul>
						<li>Nama: {{ itemToDelete.receipt_no }}</li>
					</ul>
				</modal-delete>


			</div>
		</div>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import {EventBus} from "../../eventbus";
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import SmartSearch from "../../components/SmartSearch.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"smart-search": SmartSearch,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			base_ppn:12,
			role: "",
			currentPage: 1,
			perPage: null,
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			selectedDetail: 0,
			cache: {
				editItem: {}
			},
			selectedHardwareSetup: {},
			newkwitansitypelabel: "",
			newtroubleshootlabel: "",
			newjblabel: "",
			newclientlabel: "",
			//step 1 edit
			isMobile: false,
			dataEdit: null,
			deleteId: 0,
			createErrorMessage: "Gagal Menyimpan Kwitansi Baru.",
			errorMessages: [],
			itemToDelete: {},
			kwitansis: [],
			// searchValue:'',
			loadData: true,
			savingNew: false,
			errorNew: false,
			errorList: [],
			errorSaved: false,
			newSaved: false,
			updateState: false,
			updateSaved: false,
			selectedKwitansi: 0,
			selectedTab: 0,
			updateApplicationCol: 6,
			newKwitansi: {
				type: "substitution",
				referenceId: "",
				receiptNo: "",
				notes: "",
				price: 0,
				total: 0,
				discount: 0,
				subtotal: 0,
				pic: "",
				ppn: "no",
				totalPPN: 0,
				receiptDate: "",
				clientId: "",
				clientName: "",
				hardwareQCMetadataId: ""
			},
			formActive: false,
			TableStructure: [
				//label: nama heading, key: nama object property
				{label: "No", key: null},
				{
					label: {
						id: "Nomor kwitansi",
						en: "Receipt number"
					},
					key: null
				},
				{
					label: {
						id: "Tipe",
						en: "Type"
					},
					key: null
				},
				{
					label: {
						id: "Keterangan",
						en: "Notes"
					},
					key: null
				},
				{
					label: {
						id: "Harga",
						en: "Price"
					},
					key: null
				},
				{
					label: {
						id: "Tanggal",
						en: "Date"
					},
					key: null
				},
				{
					label: {
						id: "Tindakan",
						en: "Action"
					},
					key: null
				}
			],
			dicts: {
				lang: "id",
				kwitansi: {
					id: "Kwitansi",
					en: "Receipt"
				},
				form_kwitansi: {
					id: "Form kwitansi baru ",
					en: "New receipt form"
				},
				client: {
					id: "Pelanggan",
					en: "Client"
				},
				no_jb: {
					id: "Nomor JB",
					en: "JB number"
				},
				no_jb_new: {
					id: "Nomor JB baru",
					en: "New JB number"
				},
				date: {
					id: "Tanggal",
					en: "Date"
				},
				admin_name: {
					id: "Nama admin",
					en: "Admin name"
				},
				tax: {
					id: "PPN",
					en: "Tax"
				},
				note: {
					id: "Keterangan",
					en: "Note"
				},
				price: {
					id: "Harga",
					en: "Price"
				},
				discount: {
					id: "Diskon",
					en: "Discount"
				},
				total_tax: {
					id: "Total PPN",
					en: "Total tax"
				},
				submit: {
					id: "Simpan",
					en: "Submit"
				},
				no_kwitansi: {
					id: "No kwitansi",
					en: "Kwitansi no"
				},
				type: {
					id: "Tipe",
					en: "Type"
				},
				button_add_kwitansi: {
					id: "Tambah kwitansi baru",
					en: "Add new kwitansi"
				},
				kwitansi_type: {
					id: "Tipe kwitansi",
					en: "Kwitansi type"
				},
				kwitansi_number: {
					id: "Nomor kwitansi",
					en: "Kwitansi number"
				},
				data_troubleshoot: {
					id: "Data perbaikan",
					en: "Data troubleshoot"
				}
			},
			TypeOptions: [
				{label: "Backup", value: "substitution"},
				{label: "Repair", value: "repair"},
				{label: "Replacement", value: "replacement"}
			],
			ppnTypeOptions: [
				{label: "Tidak", value: 0},
				{ label: '12', value: 12 },
				{ label: '11', value: 11 },
				{ label: '10', value: 10 },
				
			]
		};
	},
	created() {
		this.role = localStorage.getItem("role");
		console.clear();
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		console.log("user page");
		this.getKwitansi();
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			console.log("screen update");
			this.isMobile = screen.width < 768;
		});
		// this.newKwitansi.pic = localStorage.getItem("currentUser");
		this.dicts.lang = localStorage.getItem("lang");
		EventBus.$on("lang", () => {
			console.log("changing invoice item lang");
			this.dicts.lang = localStorage.getItem("lang");
		});
		
        this.getSetPpn();
	},
	methods: {
        getSetPpn(){
          axios.get(this.$baseUrl + "/api/setting?key=ppn", {
            "headers": {
              "Authorization": "Bearer " + localStorage.getItem("accessToken")
            }
          }).then((result) => {
            console.log(result);
            this.base_ppn = result.data.value;
            console.log(this.base_ppn);
          }).catch((err) => {
            //check if token fail
          });
        },
		changePage(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = myParams;
			var newUrl = this.$baseUrl + "/api/pemesanan/kwitansi-item?limit=" + this.rowLimit + "&page=" + myParams;
			this.getKwitansi(newUrl);
		},
		editPreparation(index) {
			console.log("index for edit: " + index);
			this.selectedKwitansi = index;
			console.log(this.kwitansis[index]);
			this.cache.editItem = Object.assign({}, this.kwitansis[index]);
			console.log(this.cache.editItem);
			console.log("edit journey start here");
		},
		calculateAmount() {
			
			console.log("price: " + this.newKwitansi.price);
			this.newKwitansi.price = parseInt(this.newKwitansi.price) || 0;
			this.newKwitansi.discount = parseInt(this.newKwitansi.discount) || 0;
			this.newKwitansi.subtotal = this.newKwitansi.price - this.newKwitansi.discount;
			console.log("subtotal: " + this.newKwitansi.subtotal);
			const ppnRate = parseInt(this.newKwitansi.ppn) || 0; // Ambil nilai PPN dari dropdown
			this.newKwitansi.totalPPN = this.newKwitansi.subtotal * (ppnRate / 100);
			this.newKwitansi.total = this.newKwitansi.subtotal + this.newKwitansi.totalPPN;
		},
		calculateAmountUpdate() {
			
			const selected = this.kwitansis[this.selectedKwitansi];
			console.log("price: " + selected.price);
			selected.price = parseInt(selected.price) || 0;
			selected.discount = parseInt(selected.discount) || 0;
			selected.subtotal = selected.price - selected.discount;
			console.log("subtotal: " + selected.subtotal);
			const ppnRate = parseInt(selected.ppn) || 0; // Ambil nilai PPN dari dropdown
			selected.totalPPN = selected.subtotal * (ppnRate / 100);
			selected.total = selected.subtotal + selected.totalPPN;
		},
		resetNewKwitansi() {
			this.newKwitansi.type = "";
			this.newKwitansi.referenceId = "";
			this.newKwitansi.receiptNo = "";
			this.newKwitansi.notes = "";
			this.newKwitansi.price = 0;
			this.newKwitansi.total = 0;
			this.newKwitansi.discount = 0;
			this.newKwitansi.subtotal = 0;
			this.newKwitansi.totalPPN = 0;
			this.newKwitansi.ppn = "no";
			this.newKwitansi.receiptDate = "";
			this.newKwitansi.clientId = "";
			this.newKwitansi.clientName = "";
			this.newKwitansi.hardwareQCMetadataId = "";
		},
		updateReferenceLabel(value) {
			console.log("from kwitansi: " + value);
			this.newtroubleshootlabel = value;
		},
		translateType(type) {
			var label = "";
			switch (type) {
				case "substitution":
					label = "Backup";
					break;
				case "repair":
					label = "Repair";
					break;
				case "replacement":
					label = "Replacement";
					break;
			}
			return label;
		},
		translatePPN(ppn) {
			var label = "";
			switch (ppn) {
				case "yes":
					label = "Ya";
					break;
				case "no":
					label = "Tidak";
					break;
			}
			return label;
		},
		addNewPpn(data) {
			this.newKwitansi.ppn = data;
			this.calculateAmount();
		},
		updateNewPpn(data) {
			this.kwitansis[this.selectedKwitansi].ppn = data;
			this.calculateAmountUpdate();
		},
		smartSelectAddType(data) {
			this.newKwitansi.type = data;
			this.newKwitansi.hardwareQCMetadataId = null;
		},
		smartSearchAddType(data) {
			this.newKwitansi.application_id = data.id;
		},
		smartSearchAddTroubleshoot(data) {
			this.newKwitansi.referenceId = data.id;
			this.selectedHardwareSetup = data;
			this.newKwitansi.clientName = data.hardware_setup.vessel.client.legal_name;
			this.newKwitansi.clientId = data.hardware_setup.vessel.client.id;

		},
		clearReference() {
			console.log("clearing data");
			this.newKwitansi.referenceId = "";
			this.newKwitansi.clientId = "";
			this.newKwitansi.clientName = "";
			this.selectedHardwareSetup = {};
		},
		smartSearchaddClient(data) {
			this.newKwitansi.clientName = data.legal_name;
			this.newKwitansi.clientId = data.id;
		},
		smartSearchAddJB(data) {
			this.newKwitansi.hardwareQCMetadataId = data.id;
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getKwitansi();
			}
		},
		getKwitansi(url = (this.$baseUrl + "/api/pemesanan/kwitansi-item?limit=" + this.rowLimit)) {
			this.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
                this.prevUrl = result.data.prev_page_url;
                this.nextUrl = result.data.next_page_url;
                this.currentPage = result.data.current_page;
                this.perPage = parseInt(result.data.per_page);
				this.kwitansis = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		saveNewKwitansi() {
			this.savingNew = true;
			this.errorNew = false;
			console.log(this.newKwitansi);
			if (
				this.newKwitansi.receiptNo != "" &&
				this.newKwitansi.type != ""
			) {
				axios.post(
					this.$baseUrl + "/api/pemesanan/kwitansi-item",
					{
						"type": this.newKwitansi.type,
						"reference_id": this.newKwitansi.referenceId,
						"receipt_no": this.newKwitansi.receiptNo,
						"notes": this.newKwitansi.notes,
						"price": this.newKwitansi.price,
						"total": this.newKwitansi.total,
						"discount": this.newKwitansi.discount,
						"subtotal": this.newKwitansi.subtotal,
						"pic": this.newKwitansi.pic,
						"ppn": this.newKwitansi.ppn,
						"receipt_date": this.newKwitansi.receiptDate,
						"client_id": this.newKwitansi.clientId,
						"client_name": this.newKwitansi.clientName,
						"hardware_quality_control_metadata_id": this.newKwitansi.hardwareQCMetadataId
					},
					{
						"headers":
							{
								"Authorization": "Bearer " + localStorage.getItem("accessToken")
							}
					}
				).then((result) => {
					console.log(result);
					this.getKwitansi();
					this.resetNewKwitansi();
					this.savingNew = false;
					this.newSaved = true;
					setTimeout(() => {
						this.newSaved = false;
						this.formActive = false;
					}, 1000);

				}).catch((err) => {
					//check if token fail
					if (err.response && err.response.status == 401) {
						localStorage.removeItem("accessToken");
						this.$router.push("/login");
					}
					console.log(err.response);
					this.errorList = [];
					this.errorList = Object.values(err.response.data.errors);
					console.log(this.errorList);
					this.errorNew = true;
					this.savingNew = false;
				});
			} else {
				console.log("data invalid");
				this.errorNew = true;
			}
		},
		newUsernameChange() {
			this.newKwitansi.password = this.newKwitansi.username.toUpperCase();
		},
		deleteItem(item) {
			console.log("button delete untuk user id: " + item.id);
		},
		updateUserRoleValue(newValue) {
			this.newKwitansi.role = newValue;
		},
		setNewClientId(newId) {
			this.newKwitansi.clientId = newId;
			console.log(this.newKwitansi.clientId);
		},

		updateData() {
			// console.log('updating data')
			this.updateState = true;
			this.errorSaved = false;
			console.clear();
			console.log(this.kwitansis[this.selectedKwitansi]);

			axios.put(
				this.$baseUrl + "/api/pemesanan/kwitansi-item/" + this.kwitansis[this.selectedKwitansi].id,
				this.kwitansis[this.selectedKwitansi],
				{
					"headers": {
						"Authorization": "Bearer " + localStorage.getItem("accessToken")
					}
				}
			).then((result) => {
				if (result.status = 200) {
					this.cache.editItem = this.kwitansis[this.selectedKwitansi];
					this.updateState = false;
					this.updateSaved = true;
					//step 4 edit
					// this.dataEdit = this.kwitansis[this.selectedKwitansi]
					setTimeout(() => {
						this.updateSaved = false;
						this.$bvModal.hide("modal-edit-kwitansi");
					}, 1000);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updateState = false;
				this.errorSaved = true;
				setTimeout(() => {
					this.errorSaved = false;
				}, 2000);
				console.log(err);
			});
		},
		editModalClose(mdl) {
			console.log(this.cache.editItem);
			this.$set(this.kwitansis, this.selectedKwitansi, Object.assign({}, this.cache.editItem));
			this.cache.editItem = Object.assign({}, {});
			console.log(this.kwitansis[this.selectedKwitansi]);
			this.$forceUpdate();
			// step 2 edit
			// this.$set(this.kwitansis,this.selectedKwitansi,this.dataEdit)
			// step 3 edit
			// this.dataEdit = Object.assign({},null)
			if (this.updateState) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				// mdl.hide('modal-edit-kwitansi');
			}
		},
		deleteModalClose(mdl) {
			if (this.deleteUserState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-user");
			}
		},
		detailModalClose(mdl) {
			if (this.updateState) {
				console.log("detail");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-detail-kwitansi");
			}
		},
		deleteClientData() {
			console.log("deleting data");
			this.deleteUserState = true;
			axios.delete(this.$baseUrl + "/api/master/bank/" + this.users[this.selectedToDelete].id, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				if (result.status == 200) {
					this.deleteUserState = false;
					this.userDeleted = true;
					this.users.splice(this.selectedToDelete, 1);

					setTimeout(() => {
						this.$bvModal.hide("modal-delete-user");
						this.userDeleted = false;
					}, 1500);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.deleteUserState = false;
				this.failDeleteUser = true;
				setTimeout(() => {
					this.failDeleteUser = false;
				}, 1500);
				console.log(err);
			});
		}
	}
};
</script>
<style scoped>
::v-deep .modal-content {
	margin: -3.25rem auto;
}

.btn {
	padding: 2px 6px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type=number] {
	-moz-appearance: textfield;
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
	width: 50%;
}
</style>
